import React, { useState } from "react"

import { Box, FormControl, Stack, TextField, Typography, Fade } from "@mui/material"
import { LoadingButton } from "@mui/lab"

import useAudioContext from "../../utils/eSteth/AudioState"

const DeviceForm = () => {
	const { getDevice, error, loading } = useAudioContext()
	const [name, setName] = useState("")

	const getDeviceHandler = async () => {
		await getDevice(name)
	}

	const setNameHandler = async (event) => {
		event.preventDefault()
		setName(event.target.value)
	}

	const enterNameHandler = async (event) => {
		if (event.key === "Enter") {
			await getDeviceHandler()
		}
	}

	return (
		<Fade in>
			<Box sx={{ width: "full", padding: "1rem", border: "1px solid black", borderRadius: "0.5rem" }}>
				<Stack spacing={2}>
					<Typography>Check Device</Typography>
					<FormControl>
						<TextField
							label="Device ID"
							variant="standard"
							value={name}
							onChange={setNameHandler}
							onKeyDown={enterNameHandler}
							sx={{ marginBottom: "0.5rem" }}
							error={Boolean(error.device)}
							helperText={error.device ? "Device not registered" : ""}
						/>
						<LoadingButton
							variant="contained"
							color="success"
							loading={loading.device}
							disabled={!name || loading.device}
							onClick={getDeviceHandler}
						>
							Check Device
						</LoadingButton>
					</FormControl>
				</Stack>
			</Box>
		</Fade>
	)
}

export default DeviceForm

